/*============================================================================
  SONDERMASS
==============================================================================*/

function pruefeSondermassTextFeld(name, max) {
  var sondermasstextfeld = document.getElementById(name);

  sondermasstextfeld.max = max;

  if(sondermasstextfeld.value != "") {
    if(parseInt(sondermasstextfeld.value) < parseInt(sondermasstextfeld.min)) {
      sondermasstextfeld.value = sondermasstextfeld.min;
    }
    if(parseInt(sondermasstextfeld.value) > parseInt(sondermasstextfeld.max)) {
      sondermasstextfeld.value = sondermasstextfeld.max;
    }
  }
}

function pruefeSondermassTextFeldSonderfall(nameFeld0, nameFeld1, max) {
  var sondermasstextfeld0 = document.getElementById(nameFeld0);
  var sondermasstextfeld1 = document.getElementById(nameFeld1);

  sondermasstextfeld0.max = max;
  sondermasstextfeld1.max = max;

  if(sondermasstextfeld0.value != "") {
    if(parseInt(sondermasstextfeld0.value) < parseInt(sondermasstextfeld0.min)) {
      sondermasstextfeld0.value = sondermasstextfeld0.min;
    }
    if(parseInt(sondermasstextfeld0.value) > parseInt(sondermasstextfeld0.max)) {
      sondermasstextfeld0.value = sondermasstextfeld0.max;
    }
  }

  if(sondermasstextfeld1.value != "") {
    if(parseInt(sondermasstextfeld1.value) < parseInt(sondermasstextfeld1.min)) {
      sondermasstextfeld1.value = sondermasstextfeld1.min;
    }
    if(parseInt(sondermasstextfeld1.value) > parseInt(sondermasstextfeld1.max)) {
      sondermasstextfeld1.value = sondermasstextfeld1.max;
    }
  }

  if(sondermasstextfeld0.value != "" && sondermasstextfeld1.value != "") {
    
    var wertFeld0 = parseInt(sondermasstextfeld0.value);
    var wertFeld1 = parseInt(sondermasstextfeld1.value);
    var summe = wertFeld0 + wertFeld1;

    if(wertFeld0 > wertFeld1) {
      if(wertFeld1 > 80) {
        var rest = 80;
        sondermasstextfeld1.value = rest.toString();
      }
    }
    else if(wertFeld0 < wertFeld1) {
      if(wertFeld0 > 80) {
        var rest = 80;
        sondermasstextfeld0.value = rest.toString();
      }
    }
    else {
      if(wertFeld1 > 80) {
        var rest = 80;
        sondermasstextfeld1.value = rest.toString();
      }
    }
  }
  else if(sondermasstextfeld0.value != "") {
    sondermasstextfeld0.max = max;
  }
  else if(sondermasstextfeld1.value != "") {
    sondermasstextfeld1.max = max;
  }
}

function imposeMinMax(productHandle){
  console.log("imposeMinMax");
  
  if(productHandle.includes("nali-2er-set")) {  
      pruefeSondermassTextFeld("sondermasstextfeld00", 120);
      pruefeSondermassTextFeld("sondermasstextfeld01", 20);

      pruefeSondermassTextFeld("sondermasstextfeld10", 120);
      pruefeSondermassTextFeld("sondermasstextfeld11", 20);
    }
    else if(productHandle.includes("nali")) {
      pruefeSondermassTextFeld("sondermasstextfeld00", 120);
      pruefeSondermassTextFeld("sondermasstextfeld01", 20);
    }
    else if(productHandle.includes("vana") || productHandle.includes("stenni")) {
      pruefeSondermassTextFeld("sondermasstextfeld00", 120);
    }
    else if(productHandle.includes("tensi") || productHandle.includes("rubi")) {
      pruefeSondermassTextFeldSonderfall("sondermasstextfeld00", "sondermasstextfeld01", 120);
      pruefeSondermassTextFeldSonderfall("sondermasstextfeld10", "sondermasstextfeld11", 120);
    }
}
    
function entferneText(productHandle) {
  console.log("entferneText");

  if(productHandle.includes("nali-2er-set")) {  
    var sondermasstextfeld00 = document.getElementById("sondermasstextfeld00");
    var sondermasstextfeld01 = document.getElementById("sondermasstextfeld01");
    var sondermasstextfeld10 = document.getElementById("sondermasstextfeld10");
    var sondermasstextfeld11 = document.getElementById("sondermasstextfeld11");

    sondermasstextfeld00.value = "";
    sondermasstextfeld01.value = "";
    sondermasstextfeld10.value = "";
    sondermasstextfeld11.value = "";
  }
  else if(productHandle.includes("nali")) {
    var sondermasstextfeld00 = document.getElementById("sondermasstextfeld00");
    var sondermasstextfeld01 = document.getElementById("sondermasstextfeld01");

    sondermasstextfeld00.value = "";
    sondermasstextfeld01.value = "";
  }
  else if(productHandle.includes("vana") || productHandle.includes("stenni")) {
    var sondermasstextfeld00 = document.getElementById("sondermasstextfeld00");
    sondermasstextfeld00.value = "";
  }
  else if(productHandle.includes("tensi") || productHandle.includes("rubi")) {
    var sondermasstextfeld00 = document.getElementById("sondermasstextfeld00");
    var sondermasstextfeld01 = document.getElementById("sondermasstextfeld01");
    var sondermasstextfeld10 = document.getElementById("sondermasstextfeld10");
    var sondermasstextfeld11 = document.getElementById("sondermasstextfeld11");

    sondermasstextfeld00.value = "";
    sondermasstextfeld01.value = "";
    sondermasstextfeld10.value = "";
    sondermasstextfeld11.value = "";
  }
}

// Übernimmt die Texte aus den Sprach-JSON-Dateien.
function sezteTextInputSondermass(product, variantTitle) {
  console.log('setzteTextInputSondermaß aufgerufen');

  var pathname = window.location.pathname;
  var langCode= pathname.split("/");
  var language = langCode[1];

  var label_sondermass = "Sondermaß";
  var label_erstes_sondermass = "Erstes Sondermaß";
  var label_zweites_sondermass = "Zweites Sondermaß";
  var placeholder_hoehe = "Höhe (in cm)";
  var placeholder_breite = "Breite (in cm)";
  var placeholder_tiefe = "Tiefe (in cm)";
  var placeholder_laenge = "Länge (in cm)";
  var label_yes = "Ja";
  
  if(language == "en") {
    label_sondermass = "Special size";
    label_erstes_sondermass = "First special size";
    label_zweites_sondermass = "Second special size";
    placeholder_hoehe = "Height (in cm)";
    placeholder_breite = "Width (in cm)";
    placeholder_tiefe = "Depth (in cm)";
    placeholder_laenge = "Length (in cm)";
    label_yes = "Yes";
  }
/*
  else if(language == "es") {
    label_sondermass = "Medida especial";
    label_erstes_sondermass = "Primera medida especial";
    label_zweites_sondermass = "Segunda medida especial";
    placeholder_hoehe = "Altura";
    placeholder_breite = "Ancho";
    placeholder_tiefe = "Profundidad";
    placeholder_laenge = "Longitud";
  }
  else if(language == "fr") {
    label_sondermass = "Dimension spéciale";
    label_erstes_sondermass = "Première Dimension spéciale";
    label_zweites_sondermass = "Deuxième Dimension spéciale";
    placeholder_hoehe = "Hauteur";
    placeholder_breite = "Largeur";
    placeholder_tiefe = "Profondeur";
    placeholder_laenge = "Longueur";
  }
*/

  var arrayTextInputProdukte = ['stenni', 'vana', 'nali', 'nali-2er-set', 'rubi', 'tensi'];

  var sondermassDiv = document.getElementById("sondermassdiv-" + product.id);

  if(sondermassDiv != null)
  {
    if(arrayTextInputProdukte.some(substring => product.handle.includes(substring)) && product.handle.includes("devana") == false) {
      if(product.handle.includes("nali-2er-set")) {
        var sondermassp0 = document.getElementById("sondermassp0");
        var sondermassp1 = document.getElementById("sondermassp1");

        if(variantTitle.includes(label_yes) == true) {
          var sondermasstextfeld00 = document.getElementById("sondermasstextfeld00");
          var sondermasstextfeld01 = document.getElementById("sondermasstextfeld01");

          var sondermasstextfeld10 = document.getElementById("sondermasstextfeld10");
          var sondermasstextfeld11 = document.getElementById("sondermasstextfeld11");

          var sondermasslabel0 = document.getElementById("sondermasslabel0");
          sondermasslabel0.innerHTML = label_erstes_sondermass;

          var sondermasslabel1 = document.getElementById("sondermasslabel1");
          sondermasslabel1.innerHTML = label_zweites_sondermass;

          sondermasstextfeld00.placeholder = placeholder_hoehe;
          sondermasstextfeld01.placeholder = placeholder_tiefe;

          sondermasstextfeld00.name = "properties[" + label_erstes_sondermass +" - " + placeholder_hoehe + "]";
          sondermasstextfeld01.name = "properties[" + label_erstes_sondermass +" - " + placeholder_tiefe + "]";


          sondermasstextfeld10.placeholder = placeholder_hoehe;
          sondermasstextfeld11.placeholder = placeholder_tiefe;

          sondermasstextfeld10.name = "properties[" + label_zweites_sondermass +" - " + placeholder_hoehe + "]";
          sondermasstextfeld11.name = "properties[" + label_zweites_sondermass +" - " + placeholder_tiefe + "]";

          sondermassDiv.style.display = "block";
          sondermassp0.style.display = "block";
          sondermassp1.style.display = "block";
        }
        else {
          sondermassDiv.style.display = "none";

          sondermassp0.style.display = "none";
          sondermassp1.style.display = "none";

          // Den Text entfernen, falls doch kein Sondermaß ausgewählt wurde!
          entferneText(product.handle);
        }
      }
      else if(product.handle.includes("nali")) {
        var sondermassp0 = document.getElementById("sondermassp0");

        if(variantTitle.includes(label_yes) == true) {
          var sondermasstextfeld00 = document.getElementById("sondermasstextfeld00");
          var sondermasstextfeld01 = document.getElementById("sondermasstextfeld01");

          var sondermasslabel0 = document.getElementById("sondermasslabel0");
          sondermasslabel0.innerHTML = label_sondermass;

          sondermasstextfeld00.name = "properties[" + label_sondermass + " - " + placeholder_hoehe + "]";
          sondermasstextfeld01.name = "properties[" + label_sondermass + " - " + placeholder_tiefe + "]";

          sondermasstextfeld00.placeholder = placeholder_hoehe;
          sondermasstextfeld01.placeholder = placeholder_tiefe;

          sondermassDiv.style.display = "block";
          sondermassp0.style.display = "block";
        }
        else {
          sondermassDiv.style.display = "none";

          sondermassp0.style.display = "none";

          // Den Text entfernen, falls doch kein Sondermaß ausgewählt wurde!
          entferneText(product.handle);
        }
      }
      else if(product.handle.includes("vana") || product.handle.includes("stenni")) {
        var sondermassp0 = document.getElementById("sondermassp0");

        if(variantTitle.includes(label_yes) == true || variantTitle.includes(label_sondermass) == true) {
          var sondermasstextfeld00 = document.getElementById("sondermasstextfeld00");
          var sondermasstextfeld01 = document.getElementById("sondermasstextfeld01");
          sondermasstextfeld01.style.display = "none";

          var sondermasslabel0 = document.getElementById("sondermasslabel0");
          sondermasslabel0.innerHTML = label_sondermass;

          sondermasstextfeld00.name = "properties[" + label_sondermass + " - " + placeholder_laenge + "]";
          sondermasstextfeld00.placeholder = placeholder_laenge;

          sondermassDiv.style.display = "block";
          sondermassp0.style.display = "block";
        }
        else {
          sondermassDiv.style.display = "none";

          sondermassp0.style.display = "none";

          // Den Text entfernen, falls doch kein Sondermaß ausgewählt wurde!
          entferneText(product.handle);
        }
      }
      else if(product.handle.includes("tensi") || product.handle.includes("rubi")) {
        var sondermassp0 = document.getElementById("sondermassp0");
        var sondermassp1 = document.getElementById("sondermassp1");

        if(variantTitle.includes(label_sondermass) == true) {
          var sondermasstextfeld00 = document.getElementById("sondermasstextfeld00");
          var sondermasstextfeld01 = document.getElementById("sondermasstextfeld01");

          var sondermasstextfeld10 = document.getElementById("sondermasstextfeld10");
          var sondermasstextfeld11 = document.getElementById("sondermasstextfeld11");

          sondermasstextfeld00.placeholder = placeholder_hoehe;
          sondermasstextfeld01.placeholder = placeholder_breite;

          var sondermasslabel0 = document.getElementById("sondermasslabel0");

          if(variantTitle.includes("2") == true) {
            sondermasslabel0.innerHTML = label_erstes_sondermass;

            var sondermasslabel1 = document.getElementById("sondermasslabel1");
            sondermasslabel1.innerHTML = label_zweites_sondermass;

            sondermasstextfeld10.placeholder = placeholder_hoehe;
            sondermasstextfeld11.placeholder = placeholder_breite;

            sondermasstextfeld00.name = "properties[" + label_erstes_sondermass +" - " + placeholder_hoehe + "]";
            sondermasstextfeld01.name = "properties[" + label_erstes_sondermass +" - " + placeholder_breite + "]";

            sondermasstextfeld10.name = "properties[" + label_zweites_sondermass +" - " + placeholder_hoehe + "]";
            sondermasstextfeld11.name = "properties[" + label_zweites_sondermass +" - " + placeholder_breite + "]";
            sondermassp1.style.display = "block";
          }
          else {
            sondermasstextfeld00.name = "properties[" + label_sondermass +" - " + placeholder_hoehe + "]";
            sondermasstextfeld01.name = "properties[" + label_sondermass +" - " + placeholder_breite + "]";

            sondermasslabel0.innerHTML = label_sondermass;
            sondermassp1.style.display = "none";

            // Den Text entfernen, falls doch kein Sondermaß ausgewählt wurde!
            sondermasstextfeld10.value = "";
            sondermasstextfeld11.value = "";
          }

          sondermassDiv.style.display = "block";
          sondermassp0.style.display = "block";
        }
        else {
          sondermassDiv.style.display = "none";

          sondermassp0.style.display = "none";
          sondermassp1.style.display = "none";

          // Den Text entfernen, falls doch kein Sondermaß ausgewählt wurde!
          entferneText(product.handle);
        }
      }
    }
    else {
      sondermassDiv.style.display = "none";
    }
  }
}

/*
    BOSCHMANN - ENDE
*/
